import React, { useEffect, useState } from "react";
import {
  ADD_AHU,
  getApiBaseUrl,
  GET_BLOCKS,
  ADD_ACTIVITY,
} from "../../Config/Config";
import Swal from "sweetalert2";
import { Select, Spin } from "antd";
const { Option } = Select;

const AddHostAsset = () => {
  const [disableFields, setDisableFields] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [blocks, setBlocks] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const [formData, setFormData] = useState({
    Code: "",
    description: "",
    area: "",
    department: "",
    manufacturer: "",
    modelNumber: "",
    capacity: "",
    numberOfFilters: "",
    remarks: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value !== "" ? parseInt(value) : "",
    }));
  };

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      const result = await response.json();
      if (result?.ResultData) {
        setBlocks(result.ResultData);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  // Function to send notification
  const sendNotification = async () => {
    const notificationPayload = {
      Title: "Add AHU",
      Message: "Request raised by Supervisor to Add AHU",
      RoleID: 3,
    };
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/addNotificationsToRole`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(notificationPayload),
        }
      );
      const result = await response.json();
      if (result.Status) {
        console.log("Notification sent successfully:", notificationPayload);
      } else {
        console.warn("Notification API failed:", result);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const logActivity = async (isSuccess, notes = "") => {
    try {
      const userData = sessionStorage.getItem("user");
      const user = JSON.parse(userData);

      const activityPayload = {
        ActivityType: 1,
        PerformedBy: user.UserID,
        PerformedOn: new Date().toISOString(),
        Notes: notes,
        Location: "Add AHU",
        IsSucces: isSuccess ? 1 : 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
    } catch (error) {
      console.error("Error logging activity:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let user;
    try {
      const userData = sessionStorage.getItem("user");
      console.log("User data from sessionStorage:", userData);
      if (!userData) {
        throw new Error("User data not found in session storage.");
      }
      user = JSON.parse(userData);
      if (!user.UserID) {
        throw new Error("User ID not found in user data.");
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      setIsSubmitting(false);
      return;
    }

    const payload = {
      ScreenName: "AddAHU",
      ApiName: "AddAHU",
      NewValues: {
        Code: formData.Code,
        Description: formData.description,
        Location: formData.area,
        Department: formData.department,
        Manufacturer: formData.manufacturer,
        ModelNo: formData.modelNumber,
        Capacity: formData.capacity,
        Sparescount: formData.numberOfFilters,
        Remarks: formData.remarks,
        CreatedBy: user.UserID,
      },
      UpdateValues: "",
      ScreenValues: "",
      CreatedBy: user.UserID,
    };
    console.log("Payload:", JSON.stringify(payload));
    try {
      setIsSubmitting(true);
      const response = await fetch(`${getApiBaseUrl()}${ADD_AHU}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        const result = data?.ResultData?.[0];

        if (result?.Status === "Failure") {
          await logActivity(false, "AHU add failed: " + (result?.ResultMessage || "Unknown error"));
          Swal.fire({
            icon: "error",
            title: "Submission Failed",
            text: result?.ResultMessage || "Unknown error occurred.",
          });
        } else {
          await logActivity(true, "AHU added successfully");
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: "AHU added successfully",
          });
          await sendNotification();
          window.location.reload();
        }
      } else {
        console.error("Server error:", response.statusText);
        await logActivity(false, "AHU add failed");
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to submit data. Please try again.",
        });
      }
    } catch (error) {
      console.error("Network error:", error);
      await logActivity(false, "Network error: AHU add failed");
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Failed to connect to the server. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearUserData = () => {
    setFormData({
      Code: "",
      description: "",
      area: "",
      department: "",
      manufacturer: "",
      modelNumber: "",
      capacity: "",
      numberOfFilters: "",
      remarks: "",
    });
  };

  useEffect(() => {
    const offcanvas = document.getElementById("offcanvasRightAddHostAsset");
    if (offcanvas) {
      const handleClose = () => {
        clearUserData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  const handleDownloadTemplate = async () => {
    setDisableFields(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/sample-ahu-excel`, {
        method: "GET",
      });

      if (!response.ok) throw new Error("Failed to download file");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "sample-ahu-template.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download the template. Please try again.");
    }
  };

  const handleUploadClick = async () => {
    const userData = sessionStorage.getItem("user");
    const user = JSON.parse(userData);
    if (!selectedFile) {
      Swal.fire({
        icon: "warning",
        title: "No file selected",
        text: "Please select an Excel file to upload.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("UserId", user.UserID);

    let uploadSuccess = 0;

    try {
      setIsSubmitting(true);

      const response = await fetch(`${getApiBaseUrl()}/api/upload-ahu-excel`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok && result.status) {
        uploadSuccess = 1;
        await Swal.fire({
          icon: "success",
          title: "Upload Successful",
          text: result.message,
        });
        await sendNotification();
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: result.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Error",
        text: "Something went wrong while uploading.",
      });
    } finally {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: "bulk AHU upload",
            Location: "Bulk AHU upload",
            IsSucces: uploadSuccess,
          }),
        });
      } catch (logErr) {
        console.error("Audit log error:", logErr);
      }

      setIsSubmitting(false);
      setDisableFields(false);
    }
  };

  return (
    <div>
      <style>{`
        @media (max-width: 576px) {
          #offcanvasRightAddHostAsset { width: 90% !important; }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightAddHostAsset { width: 55% !important; }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightAddHostAsset { width: 35% !important; }
        }
        @media (min-width: 1441px)  {
          #offcanvasRightAddHostAsset { width: 30% !important; }
        }
      `}</style>
      {isSubmitting && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddHostAsset"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="offcanvas-header">
              <h4 id="offcanvasRightLabel">Add AHU Machine</h4>

              <div className="d-flex align-items-center ms-auto">
                <button
                  type="submit"
                  className="btn btn-sm btn-outline-success me-2"
                  title="Save"
                  disabled={isSubmitting}
                >
                  <i className="fa fa-check fs-4"></i>
                </button>

                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
            </div>

            <hr className="m-0" />
            <div className="">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">AHU Unique Code</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    name="Code"
                    value={formData.Code}
                    onChange={handleInputChange}
                    placeholder="Enter AHU Code"
                    className="form-control"
                    disabled={disableFields}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">AHU Description</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Enter Description"
                    className="form-control"
                    disabled={disableFields}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Block</label>
                  <span className="text-danger ms-1">*</span>
                  <Select
                    showSearch
                    name="area"
                    value={formData.area || undefined}
                    onChange={(value) =>
                      handleInputChange({ target: { name: "area", value } })
                    }
                    placeholder="Select AHU Block"
                    className="w-100"
                    disabled={disableFields}
                    required
                    size="large"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {blocks.map((block) => (
                      <Option key={block.BlockId} value={block.BlockId}>
                        {block.BlockName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Department</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                    placeholder="Enter department"
                    className="form-control"
                    disabled={disableFields}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Manufacturer</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    name="manufacturer"
                    value={formData.manufacturer}
                    onChange={handleInputChange}
                    placeholder="Enter manufacturer"
                    className="form-control"
                    disabled={disableFields}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Model Number</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    name="modelNumber"
                    value={formData.modelNumber}
                    onChange={handleInputChange}
                    placeholder="Enter Model Number"
                    className="form-control"
                    disabled={disableFields}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Capacity (CFM)</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="number"
                    name="capacity"
                    value={formData.capacity}
                    onChange={handleNumberChange}
                    placeholder="Enter Capacity"
                    className="form-control"
                    disabled={disableFields}
                    min={0}
                    onWheel={(e) => e.target.blur()}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Number of Filters</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="number"
                    name="numberOfFilters"
                    value={formData.numberOfFilters}
                    onChange={handleNumberChange}
                    placeholder="Enter Number of Filters"
                    className="form-control"
                    disabled={disableFields}
                    min={0}
                    onWheel={(e) => e.target.blur()}
                    required
                  />
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Remarks</label>
                  <textarea
                    rows="2"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleInputChange}
                    placeholder="Enter Remarks"
                    className="form-control"
                    disabled={disableFields}
                  ></textarea>
                </div>
              </div>
              <hr className="mt-0" />

              <div className="col-12 d-flex justify-content-between">
                Bulk upload template:
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  title="Download Template"
                  onClick={handleDownloadTemplate}
                >
                  <i className="fa fa-download fs-4"></i>
                </button>
              </div>
            </div>
          </form>
          <div className="col-12 d-flex justify-content-start">
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="form-control form-control-sm"
              style={{ width: "200px" }}
            />
            {selectedFile && (
              <button
                className="btn btn-success btn-sm"
                onClick={handleUploadClick}
              >
                Upload Excel
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHostAsset;